export const projectList = [
  {
    id: "portfolio",
    visible: true,
    title: "portfolio.title",
    description: "portfolio.description",
    tech: "React, Tailwind, Vite",
    link: "https://omkarprabhune.com",
  },
  {
    id: "junior",
    visible: true,
    title: "junior.title",
    description: "junior.description",
    tech: "Flutter, Dart, Android",
    link: "https://github.com/OverPoweredDev/Junior",
  },
  {
    id: "apertium-webext",
    visible: false,
    title: "apertium-webext.title",
    description: "apertium-webext.description",
    tech: "JavaScript, HTML, CSS",
    link: "https://github.com/apertium/apertium-webext",
  },
  {
    id: "loop",
    visible: true,
    title: "loop.title",
    description: "loop.description",
    tech: "C++, SDL, SFML",
    link: "https://github.com/OverPoweredDev/loop",
  },
  {
    id: "wordlink",
    visible: true,
    title: "wordlink.title",
    description: "wordlink.description",
    tech: "Python, NLP, Word2Vec",
    link: "https://github.com/OverPoweredDev/WordLink",
  },
  {
    id: "dope",
    visible: false,
    title: "dope.title",
    description: "dope.description",
    tech: "Java",
    link: "https://github.com/OverPoweredDev/dope",
  },
];
